// 所有 embed 使用 modestbranding=1 减小 YouTube 角标/品牌显示
export default {
  hk: `7NAY_My61cw`,
  en: `2AVdJi-LcKc`,
  vi: `AUXIxcwNXDs`,
  th: `yVfxS0EAY2Y`,
  id: `hhsXki5FpgM`,
}